var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-model',{ref:"formModel",attrs:{"title":"表单修改","width":"700"}},[_c('Button',{attrs:{"slot":"btn","type":"primary"},on:{"click":_vm.qianzi},slot:"btn"},[_vm._v("提交验收")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2418b561","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/yhgl/biaodanxiugai.vue
// module id = null
// module chunks = 